import { useSelector } from 'react-redux';

import { selectQuotationTypeOptions } from '../services/selectors';

export const useQuotationTypeOptions = () => useSelector(selectQuotationTypeOptions);
